import axios from 'axios';

export default function linkFunds(profileId, fundIds) {
  return axios.post(`/api/v1/lwadmin/profile/${profileId}/funds`, {
    fund_ids: fundIds,
  });
}
